(function () {

    'use strict';

    angular.module('iplusjs.utils.identityType', [
        'lodash',
        'iban',
        'iplusjs.utils.misc',
        'iplusjs.utils.format'
    ])
    .service('IdentityTypeUtilsService', IdentityTypeUtilsService);

    IdentityTypeUtilsService.$inject = [
        'lodash',
        'MiscUtilsService',
        'FormatUtilsService',
        'iban'
    ];
    function IdentityTypeUtilsService(_, MiscUtilsService, FormatUtilsService, Iban) {
        var that = this,
            idProperties = 'type id formatiert'.split(' '),
            identityTypeMasks = {
                vertragsnummer: {
                    toFormatiertFnc: function (id) {
                        return FormatUtilsService.mask(_.padStart(id.toString().replace(/[^\d]/gi, ''), 11, '0'), 'V ** *** ***/***');
                    },
                    toIdFnc: function (formatiert, regexAllowedChars) {
                        if (MiscUtilsService.isAtLeastOneEmpty(formatiert, regexAllowedChars)) {
                            return;
                        }
                        return _.toString(_.toNumber(formatiert.toString().replace(regexAllowedChars, '')));
                    },
                    regexAllowedChars: new RegExp('[V\/ ]', 'gi')
                },
                partnernummer: {
                    toFormatiertFnc: function (id) {
                        return FormatUtilsService.mask(_.padStart(id.toString().replace(/[^\d]/gi, ''), 11, '0'), 'P* *** *** ***-*');
                    },
                    toIdFnc: function (formatiert, regexAllowedChars) {
                        if (MiscUtilsService.isAtLeastOneEmpty(formatiert, regexAllowedChars)) {
                            return;
                        }
                        return _.toString(_.toNumber(formatiert.toString().replace(regexAllowedChars, '')));
                    },
                    regexAllowedChars: new RegExp('[P -]', 'gi')
                },
                iban: {
                    toFormatiertFnc: function (id) {
                        return Iban.printFormat(id);
                    },
                    toIdFnc: function (formatiert) {
                        if (MiscUtilsService.isEmpty(formatiert)) {
                            return;
                        }
                        return Iban.electronicFormat(formatiert);
                    }
                },
                kfz_kennzeichen: { // eslint-disable-line camelcase
                    toFormatiertFnc: function (id) {
                        return id;
                    },
                    toIdFnc: function (formatiert) {
                        if (MiscUtilsService.isEmpty(formatiert)) {
                            return;
                        }
                        return formatiert;
                    }
                },
                vbnummer: {
                    toFormatiertFnc: function (id) {
                        return id;
                    },
                    toIdFnc: function (formatiert) {
                        if (MiscUtilsService.isEmpty(formatiert)) {
                            return;
                        }
                        return formatiert;
                    },
                    regex: new RegExp('^W[0-9]{1}(?:(?![IO])[A-Z0-9]){5}$')
                }
            };

        that.create = create;
        that.isIdentityType = isIdentityType;
        that.getId = getId;
        that.getFormatiert = getFormatiert;
        that.toId = toId;
        that.toFormatiert = toFormatiert;
        that.removeAllowedChars = removeAllowedChars;
        that.isValid = isValid;
        function create() {
            var identityType = {},
                obj = {};

            if (_.isObject(arguments[0])) {
                obj = arguments[0];
            } else if (arguments.length > 0) {
                obj.type = arguments[0];
                obj.id = arguments[1];
                obj.formatiert = arguments[2];
            }

            if (MiscUtilsService.isAtLeastOneEmpty(obj, obj.type, obj.id)) {
                return identityType;
            }

            idProperties.forEach(function (prop) {
                if (obj.hasOwnProperty(prop)) {
                    identityType[prop] = obj[prop];
                }
            });

            ['formatiert'].forEach(function (prop) {
                identityType[prop] = MiscUtilsService.isEmpty(identityType[prop]) ? toFormatiert(obj.id, obj.type) : identityType[prop];
            });

            identityType.id = _.toString(identityType.id);
            identityType.formatiert = _.toString(identityType.formatiert);

            return identityType;
        }
        function isIdentityType(value) {
            return _.isObject(value) && !_.difference(idProperties, _.keys(value)).length;
        }
        function getId(identityType) {
            return _.get(identityType, 'id');
        }
        function getFormatiert(identityType) {
            if (!isIdentityType(identityType)) {
                return;
            }

            var formatiert = _.get(identityType, 'formatiert');

            if (MiscUtilsService.isEmpty(formatiert) && MiscUtilsService.isNotEmpty(identityType)) {
                if (MiscUtilsService.isNotEmpty(identityTypeMasks[_.toLower(identityType.type)])) {
                    formatiert = toFormatiert(getId(identityType), _.toLower(identityType.type));
                }
            }

            return formatiert || getId(identityType);
        }
        function toId(value, type) {
            var identityTypeMaskTools = identityTypeMasks[_.toLower(type)];

            if (isIdentityType(value)) {
                return getId(value);
            } else {
                if (!identityTypeMaskTools || !_.isFunction(identityTypeMaskTools.toIdFnc)) {
                    return _.isObject(value) ? _.get(value, 'id') : value;
                }

                return identityTypeMaskTools.toIdFnc(value, identityTypeMaskTools.regexAllowedChars);
            }
        }
        function toFormatiert(value, type) {
            if (isIdentityType(value)) {
                return getFormatiert(value);
            }

            type = type || _.get(value, 'type');

            if (MiscUtilsService.isAtLeastOneEmpty(value, type)) {
                return;
            }

            var identityTypeMaskTools = identityTypeMasks[_.toLower(type)],
                formatiertValue = getFormatiert(value);

            if (MiscUtilsService.isEverythingEmpty(identityTypeMaskTools, formatiertValue)) {
                return _.isObject(value) ? _.get(value, 'formatiert') : value;
            }

            return formatiertValue || identityTypeMaskTools.toFormatiertFnc(value);
        }
        function removeAllowedChars(value, type) {
            if (isIdentityType(value)) {
                return getId(value);
            }

            if (MiscUtilsService.isAtLeastOneEmpty(value, type)) {
                return;
            }

            var identityTypeMaskTools = identityTypeMasks[_.toLower(type)];

            if (!identityTypeMaskTools || !identityTypeMaskTools.regexAllowedChars) {
                return value;
            }

            return value.toString().replace(identityTypeMaskTools.regexAllowedChars, '');
        }
        function isValid(value, type) {
            var validationValue = value;

            type = _.toLower(type || _.get(value, 'type'));

            if (isIdentityType(validationValue)) {
                validationValue = getId(validationValue);
            }

            if (MiscUtilsService.isEmpty(validationValue)) {
                return false;
            }

            if (type === 'partnernummer' || type === 'vertragsnummer') {
                if (_.isNaN(_.toNumber(validationValue))) {
                    return (
                        _.toNumber(toId(validationValue, type)) === _.toNumber(removeAllowedChars(validationValue, type)) &&
                        removeAllowedChars(validationValue, type).length <= 11
                    );
                } else if (_.isNumber(_.toNumber(validationValue))) {
                    return _.toNumber(validationValue).toString().length <= 11;
                }

            } else if (type === 'iban') {
                return Iban.isValid(validationValue);

            } else if (_.get(identityTypeMasks[type], 'regex')) {
                return _.get(identityTypeMasks[type], 'regex').test(validationValue);
            }
            return true;
        }
    }

})();
